import { useEffect } from "react";
import { useUserPreferences } from "../hooks/useUserPreferences";
import { DEFAULT_LANGUAGE, i18nInstance } from "./createi18nInstance";

/**
 * Keeps the active i18n language in sync with the user's `language` preference.
 */
export function I18nLanguageSync() {
  const { preferences } = useUserPreferences();

  useEffect(() => {
    const language = preferences.language ?? DEFAULT_LANGUAGE;
    if (i18nInstance.language !== language) {
      void i18nInstance.changeLanguage(language);
    }
  }, [preferences.language]);

  return null;
}
